import FormValidator from '@/js/plugins/formValidator';

export const birthdayChangeAction = (formObj) => {
    // リサイズしたときの処理
    const observer = new ResizeObserver( entries => {
        for (let entry of entries) {
            if (entry.target === formObj) {
                // メディアクエリでスマホ/PC判定
                if (window.matchMedia('(max-width: 768px)').matches) {
                    // スマホの場合の処理
                    document.querySelector('[data-name="birthday_separate"]').querySelector('.input-check-container').classList.add('nochk');
                    //document.querySelector('input[name="birthday"]').closest('.input-check-container').classList.remove('nochk');
                } else {
                    // PCの場合の処理
                    document.querySelector('[data-name="birthday_separate"]').querySelector('.input-check-container').classList.remove('nochk');
                    //document.querySelector('input[name="birthday"]').closest('.input-check-container').classList.add('nochk');
                }
            }
        }
    });
    observer.observe(formObj);

    formObj.querySelectorAll('select[name="birthday_year"], select[name="birthday_month"], select[name="birthday_day"]').forEach(selectObj => {
        selectObj.addEventListener('change', () => {
            const year = formObj.querySelector('select[name="birthday_year"]').value;
            const month = formObj.querySelector('select[name="birthday_month"]').value;
            const day = formObj.querySelector('select[name="birthday_day"]').value;
            console.log(year, month, day);
            if (year && month && day) {
                formObj.querySelector('input[name="birthday"]').value = `${year}/${month.padStart(2, '0')}/${day.padStart(2, '0')}`;
            }
        });
    });
}

const main = () => {
    if (document.querySelector('.c-parts-profile-add-guide') == null) return;

    const formValidator = new FormValidator({
        renderAreaSelector: '#input-profile-add-guide',
        renderErrorCnt: false,
        renderConfirmMessage: true,
        renderErrorPosition: 'outer',
    });
    birthdayChangeAction(formValidator.config.renderAreaObj);
}

export default main;